<template>
  <sui-form-field :width="field.width || 16" v-if="!field.hidden">
    <label>
      Ports
    </label>
    <div class="ui labeled input" :class="{error: error && error[index]}" data-inverted :data-tooltip="error && error[index] || null" v-for="(port, index) in $attrs.value" :key="index">
      <div class="ui label button dropdown" :class="{disabled: field.readonly}" @click="toggleProtocol(index)"><div class="text">{{port.protocol}}</div><i class="dropdown icon" /></div>
      <input ref="port" type="number" v-model.number="port.value" :min="field.min" :max="field.max" :readonly="field.readonly" :tabindex="field.readonly ? -1 : 0" @input="onInput()" />
      <span data-inverted data-position="left center" :data-tooltip="tooltips[port.protocol + port.value]" v-show="tooltips[port.protocol + port.value]"><i class="help circle blue fitted icon" /></span>
      <i class="trash fitted icon" :class="{disabled: field.readonly}" @click="deletePort(index)" v-show="index" />
    </div>
    <div class="ui fluid left labeled icon button" v-if="!field.readonly" @click.prevent="addPort()">
      <i class="plus icon" />
      Add port
    </div>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormServicePorts',
    mixins: [
      FormField,
    ],
    computed: {
      tooltips() {
        return this.entity.comments && this.entity.comments.ports || {}
      },
    },
    methods: {
      toggleProtocol(index) {
        this.$attrs.value[index].protocol = this.$attrs.value[index].protocol === 'TCP' ? 'UDP' : 'TCP'
        this.onInput()
      },
      addPort() {
        let maxValue = this.$attrs.value.length ? 0 : 79
        this.$attrs.value.forEach(port => {
          maxValue = Math.max(maxValue, port.value)
        })
        this.$attrs.value.push({
          protocol: 'TCP',
          ...this.$attrs.value[0],
          value: maxValue + 1,
        })
        this.onInput()
        this.$nextTick(() => {
          this.$refs.port[this.$refs.port.length - 1].focus()
        })
      },
      deletePort(index) {
        this.$attrs.value.splice(index, 1)
        this.onInput()
      },
    },
  }
</script>

<style scoped>
  .labeled.input { display: flex; align-items: center; }
  .labeled:not(:last-child) { margin-bottom: .5em!important; }
  .labeled.input input { flex: 1; }
  .error > .dropdown { border-width: 0px!important; }
  .error > input { background-color: #fff6f6!important; border-color: #e0b4b4!important; color: #9f3a38!important; }
  .trash.fitted.icon { margin-left: .7em!important; }
  .trash:hover { color: #c00; cursor: pointer; }
</style>
